
 window.onload = function () {

setTimeout(function () {
$('.product-form__buttons').css('opacity', '1');
}, 300);

if ($(window).width() <= 767) {
  setTimeout(function () {
   $('.product-gallerymedia').css('height', 'auto');
   $('.product-gallerymedia').css('overflow', 'inherit');
   }, 300); // Delay in milliseconds
}


   $("#one_review").animate({opacity:1},400);

setTimeout(function () {
  //$('.product-color-swatches input[type="radio"]').first().prop('checked', true).trigger('change');
  //$('#new-swatch .color-swatch:nth-child(1)').trigger('click');
 // $('#new-swatch .color-swatch:not(.soldout)').first().trigger('click');
}, 400); // Delay in milliseconds

/*
setTimeout(function () {
   $('product-recommendations fieldset input[type="radio"]:nth-child(2)').first().prop('checked', true).trigger('change');   
   $('product-recommendations fieldset .color-swatch:nth-child(3)').trigger('click');
   alert(1);
   
}, 3000); // Delay in milliseconds

*/
};

  $('body').on('click', '.header_h5', function(e) {
    $('.box-a1').find('.level-box').stop().slideUp();
    $(this).closest('.box-a1').find('.level-box').stop().slideToggle();

 $('.header_h5').not(this).removeClass('active');
     $(this).toggleClass('active');
});

/*
 window.onload = function () {
    setTimeout(function () {
      // ✅ Check and select the second radio input
      $('product-recommendations fieldset input[type="radio"]:nth-child(2)').prop('checked', true).trigger('change');

      // ✅ Click the third color swatch
      $('product-recommendations fieldset .color-swatch:nth-child(3)').trigger('click');

     $("#one_review").css('opacity', '1');

    }, 700); // Delay in milliseconds
};
*/